module.exports = __webpack_public_path__ + "static/media/pastafarianism.023861bd.svg";